import { Component, EventEmitter, Input, OnDestroy, Output } from '@angular/core';
import { Subject } from 'rxjs';
import { groupBy } from '../../../global/group-by';
import { AdvanceFilterParamType, IAdvancedFilterListItem, IAdvanceFilter } from './components/advance-filter';

@Component({
    selector: 'app-advanced-filters-list',
    templateUrl: './advanced-filters.component.html',
    styleUrl: './advanced-filters.component.scss'
})
export class AdvancedFiltersComponent<T> implements OnDestroy {
    private readonly _destroyed$ = new Subject<void>();
    private readonly _debounceTime: number = 500;
    private readonly _searchChange$: Subject<string> = new Subject<string>();
    private  _items : {[key:string]:IAdvancedFilterListItem<T>[] };

    searchString ='';

    @Input() loading: boolean = false;
    @Input() set items( items:IAdvancedFilterListItem<T>[]) {
        this._items =  groupBy<IAdvancedFilterListItem<T>>((items || []), 'group' );
    }

    get items (){
        // @ts-expect-errors type conversion
        return this._items;
    }

    @Output() searchChanged:EventEmitter<string> = new EventEmitter<string>();
    @Output() addNewFilter: EventEmitter< Omit<IAdvanceFilter<AdvanceFilterParamType>,'uuid'>> = new EventEmitter< Omit<IAdvanceFilter<AdvanceFilterParamType>,'uuid'>> ();

    constructor() {
    }

    ngOnDestroy(): void {
        this._destroyed$.next();
        this._destroyed$.complete();
    }

    addFilter(item): void {
        this.addNewFilter.next({
            field_type:item.field_type,
            item: item.source,
            isApplied:false,
            isOpened:true,
            text:item.text,
            icon:item.icon
        })
    }

    /**
     * Populate search param change
     * @param searchValue
     */
    onSearchChange(searchValue: string): void {
        this.searchChanged.next(searchValue)
    }
}
